import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { clearData, setAuthenticated, setUserData, setUserID } from "../store/AuthActions";
import { useDispatch, useSelector } from "react-redux";
import { selectAccessToken, selectAuthenticated, selectUserData } from "../selectors";
import { TRYON_SERVER_URL } from "../config";
import { useAuthentication } from "../Authentication";
import { logoutUser } from "../store/AuthActions";
import { useMediaQuery } from "react-responsive";
import { ChevronDownIcon, ChevronUpIcon, CircleUserIcon, CreditCardIcon, LogOutIcon, SettingsIcon, UserIcon } from "lucide-react";

export default function Navbar2(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showDropdown, setShowDropdown] = useState(false);
    const [authenticated,setAuthenticated] = useState(false);
    const userData = JSON.parse(useSelector(selectUserData));
    const dropdownRef = useRef(null);
    const { isAuthenticated } = useAuthentication();
    const isMobile = useMediaQuery({ query: `(max-width: 760px)` })
    
    useEffect(() => {
        const checkAuth = async () => {
            const authStatus = await isAuthenticated();
            setAuthenticated(authStatus);
            console.log("from auth Status", authStatus)
        };

        checkAuth();

        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
              setShowDropdown(false);
            }
          };

          document.addEventListener('mousedown', handleClickOutside);

          return () => {
            document.removeEventListener('mousedown', handleClickOutside);
          };
    }, [isAuthenticated, navigate]);
    
    const toggleDropdown = () => setShowDropdown(!showDropdown);

    const logout = () => {
        dispatch(logoutUser())
          .then(() => {
            // Redirect or perform any other actions after successful logout
            console.log("logged out succesfully!")
            // navigate('/signin');
            window.location.reload();
          })
          .catch((error) => {
            // Handle any errors that occur during logout
            console.error('Logout error:', error);
          });
      };

    function handleSelectOption(option) {
        console.log("handleSelectOption inside sidebar: ", option)
        if (props.isSidebarOpen && isMobile) {
            props.closeSideBar();
        }
        let options1 = props.options;
        console.log("options1 before", options1)
        Object.keys(options1).forEach((key) => {
            if (key === option) {
                options1[key] = true;
            } else {
                options1[key] = false;
            }
        })
        console.log("options1 after", options1)
        props.handleOptionSelect(option, options1);
    }

    return (
        <div className="relative z-10" ref={dropdownRef} id="navbar">
            <div className="flex h-14 items-center justify-between gap-2 border-b border-hairline bg-white px-3 md:h-16 md:justify-end md:px-4">
                <button onClick={props.toggleSidebar} data-drawer-target="sidebar-multi-level-sidebar" data-drawer-toggle="sidebar-multi-level-sidebar"
                    aria-controls="sidebar-multi-level-sidebar" type="button"
                    className="inline-flex shrink-0 items-center rounded-lg p-2 text-sm text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 md:hidden">
                    <span className="sr-only">Open sidebar</span>
                    <svg className="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg">
                        <path clipRule="evenodd" fillRule="evenodd"
                            d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"></path>
                    </svg>
                </button>
                <div className="flex min-w-0 flex-1 items-center justify-between gap-2">
                    <div className="flex items-center justify-start gap-4">
                        {!isMobile ? (
                            <div className="flex justify-start items-center gap-2">
                                <div className="font-Mulish text-lg font-semibold text-secondary">
                                    {props.title_description.title}
                                </div>
                                <div className="font-Mulish text-sm text-graphite">
                                    {props.title_description.description}
                                </div>
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>
                    <div>
                        { (authenticated) ? (
                                <div className="flex min-w-0 items-center justify-end gap-2">

                                    {userData && userData?.is_staff && (
                                        <button className="cursor-pointer rounded-full bg-primary-700 px-4 py-2 font-Mulish text-sm font-semibold text-white"
                                            onClick={() => handleSelectOption("admin/dashboard")}>
                                            Dashboard
                                        </button>
                                    )}

                                    <div
                                        className="flex shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 bg-white px-2.5 py-1.5 hover:bg-primary-50 sm:gap-2 sm:px-3"
                                        onClick={() => handleSelectOption("/credits")}>
                                        <CreditCardIcon className="h-4 w-4 shrink-0 text-primary-700" />
                                        <span className="font-Mulish text-sm text-primary-700">
                                            {userData?.credits ?? 0}{Number(userData?.credits_on_hold) > 0 ? " available" : " Credits"}
                                        </span>
                                        {Number(userData?.credits_on_hold) > 0 && (
                                            <span className="font-Mulish text-sm text-graphite">
                                                {userData.credits_on_hold} on hold
                                            </span>
                                        )}
                                    </div>

                                    <div className="relative">
                                        <button type="button"
                                                onClick={toggleDropdown}
                                                aria-expanded={showDropdown}
                                                aria-haspopup="menu"
                                                className="flex min-w-0 cursor-pointer items-center gap-1.5 rounded-full border border-transparent bg-white py-1.5 pl-2.5 pr-2 shadow-[0_0_0_1px_var(--hairline)] transition-colors hover:bg-hover-tint sm:gap-2.5 sm:pl-3 sm:pr-3.5"
                                                data-dropdown-toggle="dropdown">
                                            <CircleUserIcon className="h-[18px] w-[18px] shrink-0 text-graphite" aria-hidden="true" />
                                            <div className="max-w-[5.5rem] truncate font-Mulish text-sm font-semibold text-secondary sm:max-w-[10rem]">
                                                {userData?.username}
                                            </div>
                                            {showDropdown ? <ChevronUpIcon className="h-4 w-4 shrink-0 text-graphite" aria-hidden="true"/> : <ChevronDownIcon className="h-4 w-4 shrink-0 text-graphite" aria-hidden="true"/>}
                                            
                                        </button>

                                        {showDropdown && (
                                            <div
                                                className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-2xl bg-white p-2 shadow-[0_0_0_1px_var(--hairline)] focus:outline-none">
                                                <div role="none">
                                                    <div
                                                        className="flex cursor-pointer items-center gap-2 rounded-lg px-3 py-2 font-Mulish text-sm text-secondary hover:bg-primary-50"
                                                        onClick={() => {
                                                            setShowDropdown(false)
                                                            handleSelectOption("/profile")
                                                        }}><UserIcon className="h-4 w-4" aria-hidden="true"/>
                                                        Profile
                                                    </div>

                                                    <div
                                                        className="flex cursor-pointer items-center gap-2 rounded-lg px-3 py-2 font-Mulish text-sm text-secondary hover:bg-primary-50"
                                                        onClick={() => {
                                                            setShowDropdown(false)
                                                            handleSelectOption("/settings")
                                                        }}><SettingsIcon className="h-4 w-4" aria-hidden="true"/>
                                                        Settings
                                                    </div>

                                                    <div onClick={logout}
                                                        className="flex w-full cursor-pointer items-center gap-2 rounded-lg px-3 py-2 text-left font-Mulish text-sm text-secondary hover:bg-primary-50">
                                                        <LogOutIcon className="h-4 w-4" aria-hidden="true"/>
                                                        Sign out
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                </div>
                            )
                            :
                            (
                                <div>
                                    <button
                                        onClick={() => {
                                            navigate("/signin")
                                        }} 
                                        className="flex flex-row items-center justify-center rounded-full bg-primary-700 px-4 py-2"
                                    >
                                        <span className="font-Mulish text-sm font-semibold text-white">Sign in</span>
                                    </button>
                                </div>
                            )}
                    </div>
                </div>
            </div>
        </div>
    );
}